
import { defineComponent, PropType } from 'vue'

export interface AdBannerType {
  hospital_id: number
  hospital_name: string
  op_web_pc_img: string
  op_web_sp_img: string
}

export default defineComponent({
  name: 'AdBanner',

  props: {
    item: {
      type: Object as PropType<AdBannerType>,
      default: () => ({})
    },
    adType: {
      type: String
    }
  }
})
